import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import StatsGrid from "./StatsGrid";
import EditaisPanel from "./EditaisPanel";
import type { Edital } from "./EditaisPanel";
import CadastrosPendentesPanel from "./CadastrosPendentesPanel";
import ActionButtons from "./ActionButtons";
import { fetchProponentesAdmin } from "../../../services/adminService";
import type { ProponenteAdminSummary } from "../../../services/adminService";
import editaisAdminService from "../../../services/editaisAdminService";
import type { Edital as EditalAPI } from "../../../services/editaisAdminService";

export default function HomeAdmin() {
  const [proponentes, setProponentes] = useState<ProponenteAdminSummary[]>([]);
  const [editais, setEditais] = useState<Edital[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        setIsLoading(true);

        // Carregar proponentes
        const proponentesData = await fetchProponentesAdmin();
        setProponentes(proponentesData);

        // Carregar editais
        const editaisData = await editaisAdminService.listar();

        // Mapear editais da API para o formato do componente
        // Buscar estatísticas em paralelo
        const editaisComEstatisticas = await Promise.all(
          editaisData.editais.map(async (ed: EditalAPI) => {
            try {
              const estatisticas = await editaisAdminService.estatisticas(
                ed.id
              );
              return {
                id: ed.id.toString(),
                titulo: ed.nome,
                modalidade: "Universal", // Pode ser extraído de configurações depois
                inscricoes: estatisticas.estatisticas?.total_inscricoes || 0,
                status:
                  ed.status === "publicado"
                    ? "Aberto"
                    : ed.status === "encerrado"
                    ? "Encerrado"
                    : "Rascunho",
                dataFim: ed.data_fim,
              };
            } catch {
              // Se falhar ao buscar estatísticas, retorna sem inscricoes
              return {
                id: ed.id.toString(),
                titulo: ed.nome,
                modalidade: "Universal",
                inscricoes: 0,
                status:
                  ed.status === "publicado"
                    ? "Aberto"
                    : ed.status === "encerrado"
                    ? "Encerrado"
                    : "Rascunho",
                dataFim: ed.data_fim,
              };
            }
          })
        );

        setEditais(editaisComEstatisticas);
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
        toast.error("Erro ao carregar dados do dashboard");
      } finally {
        setIsLoading(false);
      }
    };
    load();
  }, []);

  const stats = {
    editaisAtivos: editais.filter((e) => e.status === "Aberto").length,
    totalProponentes: proponentes.length,
    cadastrosPendentes: proponentes.filter((p) => p.documentos_pendentes)
      .length,
    projetosAvaliacao: 156, // TODO: implementar quando houver projetos
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Carregando dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="p-6">
        {/* Stats Grid */}
        <StatsGrid stats={stats} />

        <div className="grid grid-cols-3 gap-6">
          <div className="col-span-2">
            <EditaisPanel editais={editais} />
          </div>
          <div className="col-span-1">
            <CadastrosPendentesPanel proponentes={proponentes} />
          </div>
        </div>

        <ActionButtons />
      </div>
    </div>
  );
}
